module.exports = __webpack_public_path__ + "/images/shop/caris-cockpit/help_caris_FR2.jpg";